




import {Vue, Component} from "vue-property-decorator";

@Component
export default class Result extends Vue {
    mounted(){
        setTimeout(response => {
            location.href = String(this.$route.query.referer);
        },1000);

    }
}
